import type { ConversationId, MessageId } from '@cyphex/types/common';

export const POST_KEYS = {
  all: ['posts'] as const,
  feed: (conversationId: ConversationId) => [...POST_KEYS.all, 'feed', conversationId] as const,
  pinned: (conversationId: ConversationId) => [...POST_KEYS.all, 'pinned', conversationId] as const,
  thread: (conversationId: ConversationId, rootId: MessageId) =>
    [...POST_KEYS.all, 'thread', conversationId, rootId] as const,
} as const;
